import { RouteObject } from "react-router-dom";
import { PrintFormatFamilyListPage } from "@/pages/printing/PrintFormatFamilyListPage";
import { PrintFormatFamilyDetailPage } from "@/pages/printing/PrintFormatFamilyDetailPage";
import { PrintFormatDesignerPage } from "@/pages/printing/PrintFormatDesignerPage";
import PrintFormatFamilyListHelp from "@/pages/printing/help/print-format-family-list.mdx";
import PrintFormatFamilyDetailHelp from "@/pages/printing/help/print-format-family-detail.mdx";

export const printingRoutes: RouteObject[] = [
  {
    path: "/help/printing/print-format-family-list",
    element: <PrintFormatFamilyListHelp />,
  },
  {
    path: "/help/printing/print-format-family-detail",
    element: <PrintFormatFamilyDetailHelp />,
  },
  {
    path: "/help/printing/designer",
    element: <PrintFormatFamilyDetailHelp />,
  },
  {
    path: "/printing",
    element: <PrintFormatFamilyListPage />,
  },
  {
    path: "/printing/:id",
    element: <PrintFormatFamilyDetailPage />,
  },
  {
    path: "/printing/:familyId/designer/:revisionId?",
    element: <PrintFormatDesignerPage />,
  },
];
